var WDN = WDN || {};

if (typeof WDN.Debounce === "undefined") {
  WDN.Debounce = (function () {
    var Debounce = function (Function, WaitTime) {
      var Timer;
      return function () {
        var This = this,
          args = arguments;
        var later = function () {
          Timer = null;
          Function.apply(This, args);
        };
        clearTimeout(Timer);
        Timer = setTimeout(later, WaitTime);
      };
    };
    return Debounce;
  })();
}
